import * as S from "./DetailDataItemBox.styles";

export interface DetailDataItemBoxProps {
  label?: string;
  content?: string | number;
  route?: boolean;
  fontWeight?: string;
  fontSize?: string;
  dateFontSize?: string;
  contentColor?: string;
}

export const DetailDataItemBox = ({
  label,
  content,
  route,
  fontWeight,
  fontSize,
  dateFontSize,
  contentColor,
}: DetailDataItemBoxProps) => {
  return (
    <S.DetailDataItemBox route={route ? true : false} fontWeight={fontWeight}>
      <S.DetailDataLabelSpan fontSize={fontSize}>{label}</S.DetailDataLabelSpan>
      <S.DetailDataContentBox
        dateFontSize={dateFontSize}
        contentColor={contentColor}
      >
        {content ? content : "-"}
      </S.DetailDataContentBox>
    </S.DetailDataItemBox>
  );
};
